module.exports = __webpack_public_path__ + "img/Transprompt Freight.857b2e6a.png";